import Classes from '@/styles/components/setupmodel/_index.module.scss';

function SetupPopup(props) {
  const hide_class = props.hide_class ? 'hide_modal' : ''
  return (props.trigger) ? (
    <div className={`${Classes.SetupPopup} SetupPopup ${hide_class}`}>
        {props.children}
    </div>
  ) : "";
}

export default SetupPopup;
